import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Stars.css';

const Stars = ({
  rating = 0,
  maxStars = 5,
  editable = false,
  starSize,
  fullColor,
  emptyColor,
  onChange,
  className = 'stars-container',
  starClassName = 'star',
  filledClassName = 'star-filled',
  editableClassName = 'star-editable'
}) => {
  const [hoverRating, setHoverRating] = useState(0);

  const handleClick = (newRating) => {
    if (editable && onChange) {
      onChange(newRating);
    }
  };

  const handleMouseEnter = (hoverValue) => {
    if (editable) {
      setHoverRating(hoverValue);
    }
  };

  const handleMouseLeave = () => {
    if (editable) {
      setHoverRating(0);
    }
  };

  return (
    <div className={className}>
      {[...Array(maxStars)].map((_, index) => {
        const starValue = index + 1;
        const isFilled = starValue <= (hoverRating || rating);
        
        const style = {};
        if (starSize) {
          style.fontSize = `${starSize}px`;
        }
        if (isFilled && fullColor) {
          style.color = fullColor;
        } else if (!isFilled && emptyColor) {
          style.color = emptyColor;
        }
        
        return (
          <span
            key={index}
            className={`${starClassName} ${isFilled ? filledClassName : ''} ${editable ? editableClassName : ''}`}
            style={style}
            onClick={() => handleClick(starValue)}
            onMouseEnter={() => handleMouseEnter(starValue)}
            onMouseLeave={handleMouseLeave}
          >
            {isFilled ? '★' : '☆'}
          </span>
        );
      })}
    </div>
  );
};

Stars.propTypes = {
  rating: PropTypes.number,
  maxStars: PropTypes.number,
  editable: PropTypes.bool,
  starSize: PropTypes.number,
  fullColor: PropTypes.string,
  emptyColor: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  starClassName: PropTypes.string,
  filledClassName: PropTypes.string,
  editableClassName: PropTypes.string
};

export default Stars;